export default __webpack_public_path__ + "static/media/pic51.f9bbc182.JPG";